export default __webpack_public_path__ + "static/media/search.034cc1ec.svg";